export function getAllUrlParams(url? : string) {

  let queryString : string = url ? url.split('?')[1] : window.location.search.slice(1);

  let obj : any = {};

  if (queryString) {
    queryString = queryString.split('#')[0];

    let arr : string[] = queryString.split('&');

    for (let i = 0; i < arr.length; i++) {
      let a = arr[i].split('=');

      // in case params look like: list[]=thing1&list[]=thing2
      let paramNum = undefined;
      let paramName = a[0].replace(/\[\d*\]/, function(v) {
        paramNum = v.slice(1 , -1);
        return '';
      });

      let paramValue = typeof(a[1]) === 'undefined' ? true : decodeURIComponent(a[1]);

      if (obj[paramName]) {
        if (typeof obj[paramName] === 'string') {
          obj[paramName] = [obj[paramName]];
        }
        if (typeof paramNum === 'undefined') {
          obj[paramName].push(paramValue);
        }
        else {
          obj[paramName][paramNum] = paramValue;
        }
      }
      else {
        obj[paramName] = paramValue;
      }
    }
  }

  return obj;
}

export const buildQuerystring = (keyvaluePair: any) : string => {
  let urlSearchParams = new URLSearchParams();
  
  for(const property in keyvaluePair) {
    if(Array.isArray(keyvaluePair[property])) {
      const array = keyvaluePair[property] as Array<any>;
      for(const arrayItem in array) {
        urlSearchParams.append(property, array[arrayItem]);
      }
    }
    else {
      urlSearchParams.append(property, keyvaluePair[property]);
    }
  }

  return urlSearchParams.toString();
};